import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

interface DateCountResponse {
    total_order_count: number;
    total_sales_amount: number;
    total_order_amount: number; // 발주금액 합계 (지점 포털 합계 표시용)
}

export const useGetOrderDateCount = (
    start_date: string,
    end_date: string,
    filterData?: {
        order_status: number[];
        payment_status: number[];
        branch_type: number[];
        selected_customers?: string[];
        selected_branches?: string[];
        selected_delivery?: string[];
    },
    userOrder?: string,
): UseQueryResult<DateCountResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<DateCountResponse, Error>({
        queryKey: ["getOrderDateCount", start_date, end_date, userOrder],
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.get_order_date_count}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                params: {
                    start_date,
                    end_date,
                    order_status: filterData?.order_status,
                    payment_status: filterData?.payment_status || undefined,
                    branch_type: filterData?.branch_type || undefined,
                    customer_name: filterData?.selected_customers || undefined,
                    branch_name: filterData?.selected_branches || undefined,
                    delivery_name: filterData?.selected_delivery || undefined,
                    userOrder: userOrder || undefined,
                },
            });
            return response.data.data;
        },
        placeholderData: prevData => {
            if (prevData) {
                return {
                    ...prevData,
                };
            }
            return undefined;
        },
    });
};
